export const REFINEMENT_HEADER = 'Web.RefinementInterface.v1_0.RefinementHeaderElement';
